









import { Vue, Component } from 'vue-property-decorator'
import SignIn from 'components/auth/SignIn.vue'
import SignInConsent from 'components/auth/SignInConsent.vue'

@Component({
  components: {
    SignIn,
    SignInConsent
  }
})
export default class PageSignIn extends Vue {

  start () {
    window.document.location.href = process.env.VUE_ROUTER_BASE + ''
  }
}
